import React from "react";
import Checkbox from "blocks/filters/Checkbox";
import RadioButton from "blocks/filters/RadioButton";
import _ from "lodash";
import { inject } from "mobx-react";
import { observe } from "mobx";
import classNames from "classnames";
import FilterCountySelect from "blocks/FilterCountySelect";
import FilterDateSelect from "blocks/FilterDateSelect";
import { withRouter } from "react-router-dom";
export const COUNTIES = [
  { title: "All", value: "All" },
  { title: "Antrim", value: "Antrim" },
  { title: "Armagh", value: "Armagh" },
  { title: "Carlow", value: "Carlow" },
  { title: "Cavan", value: "Cavan" },
  { title: "Clare", value: "Clare" },
  { title: "Cork", value: "Cork" },
  { title: "Derry", value: "Derry" },
  { title: "Donegal", value: "Donegal" },
  { title: "Down", value: "Down" },
  { title: "Dublin", value: "Dublin" },
  { title: "Fermanagh", value: "Fermanagh" },
  { title: "Galway", value: "Galway" },
  { title: "Kerry", value: "Kerry" },
  { title: "Kildare", value: "Kildare" },
  { title: "Kilkenny", value: "Kilkenny" },
  { title: "Laois", value: "Laois" },
  { title: "Leitrim", value: "Leitrim" },
  { title: "Limerick", value: "Limerick" },
  { title: "Longford", value: "Longford" },
  { title: "Louth", value: "Louth" },
  { title: "Mayo", value: "Mayo" },
  { title: "Meath", value: "Meath" },
  { title: "Monaghan", value: "Monaghan" },
  { title: "Offaly", value: "Offaly" },
  { title: "Roscommon", value: "Roscommon" },
  { title: "Sligo", value: "Sligo" },
  { title: "Tipperary", value: "Tipperary" },
  { title: "Tyrone", value: "Tyrone" },
  { title: "Waterford", value: "Waterford" },
  { title: "Westmeath", value: "Westmeath" },
  { title: "Wexford", value: "Wexford" },
  { title: "Wicklow", value: "Wicklow" }
];
const defaultState = {
  defaultPrefix: "My",
  filterTitle: '',
  isRegular: false,
  activeTab: null,
  filters: {
    venue_county: "All",
    date_to: null,
    date_from: null,
    audience: [
      { value: 0, title: "All", checked: true },
      // { value: 1, title: "Counsellors", checked: false },
      // { value: 2, title: "Psychotherapists", checked: false },
      // { value: 4, title: "Psychiatrists", checked: false },
      // { value: 6, title: "Students", checked: false },
      { value: 11, title: "All Therapists", checked: false },
      { value: 3, title: "Psychologists", checked: false },
      { value: 5, title: "Supervisors", checked: false },
      { value: 7, title: "Other Healthcare Professionals", checked: false },
      { value: 8, title: "Life Coaches", checked: false },
      // { value: 10, title: "General Public", checked: false }
    ],
    price: [
      { value: null, title: "Both", active: true, key: "price_1" },
      { value: "paid", title: "Paid", active: false, key: "price_2" },
      { value: "free", title: "Free", active: false, key: "price_3" }
    ],
    cpd_hours: [
      { value: null, title: "Both", active: true, key: "cpd_1" },
      { value: "yes", title: "Yes", active: false, key: "cpd_2" },
      { value: "no", title: "No", active: false, key: "cpd_3" }
    ],
    workshop_type: [
      { value: 0, title: "All", active: true, key: "cpd_0" },
      { value: 2, title: 'Webinar', active: false, key: 'type_1' },
      { value: 1, title: 'Online Workshop', active: false, key: 'type_2' },
      { value: 3, title: 'Public Webinar', active: false, key: 'type_3' },
      { value: 5, title: 'Public Workshop', active: false, key: 'type_5' },
      // { value: 4, title: 'Organisation', active: false, key: 'type_4' },
    ],
  }
};
const ACTIVE_AUDIENCE = "audience";
const ACTIVE_PRICE = "price";
const ACTIVE_CPD = "cpd";
const ACTIVE_SELECT = "select";
const ACTIVE_TYPE = "type";


@inject("searchFieldEventEmitter", "filter")
@withRouter
export default class MyWorkShopFilters extends React.Component {
  state = _.cloneDeep(defaultState);

  resetFilters = (data) => {
    this.setState({
      filters: _.cloneDeep(defaultState.filters)
    });
    if (data) {
      this.props.history.push(this.props.location.pathname);
      this.props.submitFilter(`&page=${this.props.searchFieldEventEmitter.page}`);
    }
  };

  handleChangeCheckbox = data => {
    let newAudience = _.assign({}, this.state.filters);

    if (data.index === 0 && data.checked) {
      newAudience.audience = _.cloneDeep(defaultState.filters.audience);
    } else {
      newAudience.audience[data.index] = _.assign(
        {},
        this.state.filters.audience[data.index],
        data
      );
      if (newAudience.audience[0].checked) {
        newAudience.audience[0] = _.assign(
          {},
          this.state.filters.audience[0],
          {checked: false}
        );
      }
      const allEmpty = newAudience.audience.filter(field => field.checked);
      if (!allEmpty.length) {
        newAudience.audience[0] = _.assign(
          {},
          this.state.filters.audience[0],
          {checked: true}
        );
      }
    }

    this.setState({ filters: newAudience });
  };

  handleChangeRadioPrice = data => {
    let newAudience = _.assign({}, this.state.filters);
    newAudience.price = _.assign([], newAudience.price);
    newAudience.price = _.map(newAudience.price, (el, i) => {
      el.active = i === Number(data.index.charAt(0));
      return el;
    });
    this.setState({ filters: newAudience });
  };

  handleChangeCpHours = data => {
    let newAudience = _.assign({}, this.state.filters);
    newAudience.cpd_hours = _.map(newAudience.cpd_hours, (el, i) => {
      el.active = i === Number(data.index.charAt(0));
      return el;
    });
    this.setState({ filters: newAudience });
  };

  handleChangeWorkshopType = selectedData => {
    // let newAudience = _.assign({}, this.state.filters);
    // newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
    //   el.active = i === Number(data.index.charAt(0));
    //   return el;
    // });
    // this.setState({ filters: newAudience });
    const data = {
      ...selectedData,
      active: selectedData.checked,
    };
    let newAudience = _.assign({}, this.state.filters);

    if (Number(data.index.charAt(0)) === 0 && data.active) {
      newAudience.workshop_type = _.cloneDeep(defaultState.filters.workshop_type);
    } else {
      newAudience.workshop_type[Number(data.index.charAt(0))] = _.assign(
        {},
        this.state.filters.workshop_type[Number(data.index.charAt(0))],
        data
      );
      if (newAudience.workshop_type[0].active) {
        newAudience.workshop_type[0] = _.assign(
          {},
          this.state.filters.workshop_type[0],
          {active: false}
        );
      }
      const allEmpty = newAudience.workshop_type.filter(field => field.active);
      if (!allEmpty.length) {
        newAudience.workshop_type[0] = _.assign(
          {},
          this.state.filters.workshop_type[0],
          {active: true}
        );
      }
    }

    this.setState({ filters: newAudience });
  }

  handleChange = data => {
    let filters = _.assign({}, this.state.filters, data);
    this.setState({ filters: filters });
  };

  handleSubmit = e => {
    if(e)
      e.preventDefault();
    this.props.searchFieldEventEmitter.setInitialState();
    this.buildRequest();
    this.saveFilter();
  };

  saveFilter = () => {
    var userFilter = this.state.filters;
    this.props.filter.setFilter(userFilter);
  };

  componentWillReceiveProps = newProps => {
    this.setState({
      title: newProps.title,
      count: newProps.count,
      defaultPrefix: newProps.defaultPrefix,
    });
    if(!!(newProps.location.state && newProps.location.state.cpd_hours) && !!(!this.props.location.state || !!(this.props.location.state && !this.props.location.state.cpd_hours))) {
      let newAudience = _.cloneDeep(defaultState.filters);
      newAudience.cpd_hours = _.map(newAudience.cpd_hours, (el, i) => {
        el.active = i === 1;
        return el;
      });
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = i === 1 || i === 2;
        return el;
      });
      this.setState({ filters: newAudience }, () => this.handleSubmit());
    }
    if(!!(newProps.location.state && newProps.location.state.other) && !!(!this.props.location.state || !!(this.props.location.state && !this.props.location.state.other))) {
      let newAudience = _.cloneDeep(defaultState.filters);
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = i === 1 || i === 2;
        return el;
      });
      newAudience.cpd_hours = _.map(newAudience.cpd_hours, (el, i) => {
        el.active = i === 2;
        return el;
      });
      this.setState({ filters: newAudience }, () => this.handleSubmit());
    }
    if(!!(newProps.location.state && newProps.location.state.group) && !!(!this.props.location.state || !!(this.props.location.state && !this.props.location.state.group))) {
      let newAudience = _.cloneDeep(defaultState.filters);
      let newFilterTitle = 'Public Webinars';
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = el.value === 3;
        return el;
      });
      newAudience.cpd_hours = _.map(newAudience.cpd_hours, (el, i) => {
        el.active = i === 0;
        return el;
      });
      this.setState({ filters: newAudience, filterTitle: newFilterTitle }, () => this.handleSubmit());
    }
    if(!!(newProps.location.state && newProps.location.state.public) && !!(!this.props.location.state || !!(this.props.location.state && !this.props.location.state.public))) {
      let newAudience = _.cloneDeep(defaultState.filters);
      let newFilterTitle = 'Public Workshops';
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = el.value === 5;
        return el;
      });
      newAudience.cpd_hours = _.map(newAudience.cpd_hours, (el, i) => {
        el.active = i === 0;
        return el;
      });
      this.setState({ filters: newAudience, filterTitle: newFilterTitle }, () => this.handleSubmit());
    }
    if(!!(newProps.location.state && newProps.location.state.organizations) && !!(!this.props.location.state || !!(this.props.location.state && !this.props.location.state.organizations))) {
      let newAudience = _.cloneDeep(defaultState.filters);
      let newFilterTitle = 'organization';
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = el.value === 4;
        return el;
      });
      newAudience.cpd_hours = _.map(newAudience.cpd_hours, (el, i) => {
        el.active = i === 0;
        return el;
      });
      this.setState({ filters: newAudience, filterTitle: newFilterTitle }, () => this.handleSubmit());
    }
    if(!!(newProps.location.state && newProps.location.state.webinar) && !!(!this.props.location.state || !!(this.props.location.state && !this.props.location.state.webinar))) {
      let newAudience = _.cloneDeep(defaultState.filters);
      let newFilterTitle = 'Live webinars';
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = i === 1;
        return el;
      });
      newAudience.cpd_hours = _.map(newAudience.cpd_hours, (el, i) => {
        el.active = i === 0;
        return el;
      });
      this.setState({ filters: newAudience, filterTitle: newFilterTitle }, () => this.handleSubmit());
    }
    if(!!(newProps.location.state && newProps.location.state.online) && !!(!this.props.location.state || !!(this.props.location.state && !this.props.location.state.online))) {
      let newAudience = _.cloneDeep(defaultState.filters);
      let newFilterTitle = 'Online workshops';
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = i === 2;
        return el;
      });
      newAudience.cpd_hours = _.map(newAudience.cpd_hours, (el, i) => {
        el.active = i === 0;
        return el;
      });
      this.setState({ filters: newAudience, filterTitle: newFilterTitle }, () => this.handleSubmit());
    }
  };

  init = () => {
    this.initializeType(this.props.location);
    this.listener = this.props.history.listen(location => {
      this.initializeType(location);
    });

    if (this.props.filter.value.venue_county) {
      this.setState({
        ...this.state,
        filters: this.props.filter.value
      });
    }
    if(this.props.location.state && this.props.location.state.cpd_hours) {
      let newAudience = _.cloneDeep(defaultState.filters);
      newAudience.cpd_hours = _.map(newAudience.cpd_hours, (el, i) => {
        el.active = i === 1;
        return el;
      });
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = i === 1 || i === 2;
        return el;
      });
      this.setState({ filters: newAudience }, () => this.handleSubmit());
    }
    if(this.props.location.state && this.props.location.state.other) {
      let newAudience = _.cloneDeep(defaultState.filters);
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = i === 1 || i === 2;
        return el;
      });
      newAudience.cpd_hours = _.map(newAudience.cpd_hours, (el, i) => {
        el.active = i === 2;
        return el;
      });
      this.setState({ filters: newAudience }, () => this.handleSubmit());
    }
    if(this.props.location.state && this.props.location.state.group) {
      let newAudience = _.cloneDeep(defaultState.filters);
      let newFilterTitle = 'Public Webinars';
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = el.value === 3;
        return el;
      });
      this.setState({ filters: newAudience, filterTitle: newFilterTitle }, () => this.handleSubmit());
    }
    if(this.props.location.state && this.props.location.state.public) {
      let newAudience = _.cloneDeep(defaultState.filters);
      let newFilterTitle = 'Public Workshops';
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = el.value === 5;
        return el;
      });
      this.setState({ filters: newAudience, filterTitle: newFilterTitle }, () => this.handleSubmit());
    }
    if(this.props.location.state && this.props.location.state.organizations) {
      let newAudience = _.cloneDeep(defaultState.filters);
      let newFilterTitle = 'organization';
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = el.value === 4;
        return el;
      });
      this.setState({ filters: newAudience, filterTitle: newFilterTitle }, () => this.handleSubmit());
    }
    if(this.props.location.state && this.props.location.state.webinar) {
      let newAudience = _.cloneDeep(defaultState.filters);
      let newFilterTitle = 'Live webinars';
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = i === 1;
        return el;
      });
      this.setState({ filters: newAudience, filterTitle: newFilterTitle }, () => this.handleSubmit());
    }
    if(this.props.location.state && this.props.location.state.online) {
      let newAudience = _.cloneDeep(defaultState.filters);
      let newFilterTitle = 'Online workshops';
      newAudience.workshop_type = _.map(newAudience.workshop_type, (el, i) => {
        el.active = i === 2;
        return el;
      });
      this.setState({ filters: newAudience, filterTitle: newFilterTitle }, () => this.handleSubmit());
    }
  }

  // componentWillMount = () => {
  //   setTimeout(() => this.init(), 1000);
  // };

  initializeType = location => {
    if (location.pathname.includes("regular"))
      this.setState({ isRegular: true });
    else this.setState({ isRegular: false });
  };

  buildRequest = () => {
    let audiences = _.filter(this.state.filters.audience, el => {
      if (el.value === 0) return false;
      return el.checked
    });
    let price = _.filter(this.state.filters.price, el => el.active)[0];
    let cpdHours = _.filter(this.state.filters.cpd_hours, el => el.active)[0];
    // let workshop_type = _.filter(this.state.filters.workshop_type, el => el.active)[0];
    let workshop_type = _.filter(this.state.filters.workshop_type, el => {
      if (el.value === 0) return false;
      return el.active
    });
    let audienceQuery = _.map(audiences, el => `audience[]=${el.value}`).join(
      "&"
    );
    audienceQuery = audienceQuery + workshop_type.map(el => `workshop_types[]=${el.value}`).join(
      "&"
    );
    if (price.value !== null)
      audienceQuery = audienceQuery + `&price=${price.value}`;
    if (cpdHours.value !== null)
      audienceQuery = audienceQuery + `&cpd_hours=${cpdHours.value}`;
    // if (workshop_type && workshop_type.value !== 'all')
    //   audienceQuery = audienceQuery + `&workshop_type=${workshop_type.value}`;
    if (this.state.title)  
      audienceQuery = audienceQuery + `&title=${this.state.title}`;
    if (this.state.filters.venue_county !== "All") {
      audienceQuery =
        audienceQuery + `&venue_county=${this.state.filters.venue_county}`;
    }
    if (this.state.filters.date_to) {
      audienceQuery =
        audienceQuery + `&date_to=${this.state.filters.date_to.format()}`;
    }
    if (this.state.filters.date_from) {
      audienceQuery =
        audienceQuery + `&date_from=${this.state.filters.date_from.format()}`;
    }
    const url =
      audienceQuery + `&page=${this.props.searchFieldEventEmitter.page}`;

    this.props.filter.setFilterUrl(url);

    if (this.props.searchFieldEventEmitter.allowReloadAndPush) {
      // this.props.history.push(this.props.location.pathname + '?' + url);

      this.props.submitFilter(
        audienceQuery + `&page=${this.props.searchFieldEventEmitter.page}`
      );
    }


  };

  componentWillMount = () => {
    this.setState({ count: this.props.count });
    this.init();

    this.subscriber = observe(this.props.searchFieldEventEmitter, "event", () =>
      this.buildRequest()
    );
    this.subscriber = observe(this.props.searchFieldEventEmitter, "page", () =>
      this.buildRequest()
    );

    this.subscriberReset = observe(
      this.props.searchFieldEventEmitter,
      "resetEvent",
      () => this.resetFilters()
    );
  };

  componentWillUnmount = () => {
    if (!window.location.href.includes("/admin/regular/")) {
      this.props.filter.clearFilter();
    }
    this.subscriber();
    this.subscriberReset();
    this.listener();
  };

  activateTab = type => {
    if (this.state.activeTab === type) this.setState({ activeTab: null });
    else this.setState({ activeTab: type });
  };

  handleSortAudience = obj => {
    let newArr = obj.sort((first, second) => {
      let firstItem = first.title;
      let secondItem = second.title;

      if (firstItem > secondItem) {
        return 1;
      } else if (firstItem < secondItem) {
        return -1;
      } else {
        return 0;
      }
    });

    return newArr;
  };

  renderOnlineFilters = () => {
    return (
      <form
        className="filter"
        onSubmit={this.handleSubmit}
        style={this.props.style}
      >
        <h2 className="workshop-list-title workshop-list-top-holder  hide-xs hide-s">
          {this.state.filterTitle ? this.state.filterTitle : `${this.state.defaultPrefix} WORKSHOPS`}
          <span>({this.state.count})</span>
        </h2>
        {/* <div className="filter-group-holder">
          <p
            className={classNames("filter-title custom-style-padding", {
              active: this.state.activeTab === ACTIVE_TYPE
            })}
            onClick={() => this.activateTab(ACTIVE_TYPE)}
          >
            Workshop Type
          </p>
          <div
            className={classNames("filter-group", {
              hideElement: this.state.activeTab !== ACTIVE_TYPE
            })}
          >
            <div className="row">
              {this.state.filters.workshop_type.map((el, i) => (
                // <RadioButton
                //   key={i}
                //   id={`${i}-type`}
                //   type="workshop_type"
                //   label={el.title}
                //   checked={el.active}
                //   handleChange={this.handleChangeWorkshopType}
                //   className={el.key === 'type_2' ? 'col-8' : 'col-4'}
                // />
                <Checkbox
                  key={i}
                  value={el.value}
                  id={`${i}-type`}
                  // id={i}
                  label={el.title}
                  checked={el.active}
                  handleChange={this.handleChangeWorkshopType}
                  fullWidth
                />
              ))}
            </div>
          </div>
        </div> */}
        <div className="filter-group-holder filter-group-holder-price">
          <p
            className={classNames("filter-title", {
              active: this.state.activeTab === ACTIVE_PRICE
            })}
            onClick={() => this.activateTab(ACTIVE_PRICE)}
            style={{ textTransform: "initial" }}
          >
            PRICE
          </p>
          <div
            className={classNames("filter-group", {
              hideElement: this.state.activeTab !== ACTIVE_PRICE
            })}
          >
            <div className="row">
              {this.state.filters.price.map((el, i) => (
                <RadioButton
                  key={i}
                  id={`${i}-price`}
                  type="price"
                  label={el.title}
                  checked={el.active}
                  handleChange={this.handleChangeRadioPrice}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="filter-group-holder filter-group-holder-cpd">
          <p
            className={classNames("filter-title", {
              active: this.state.activeTab === ACTIVE_CPD
            })}
            onClick={() => this.activateTab(ACTIVE_CPD)}
          >
            CPD HOURS
          </p>
          <div
            className={classNames("filter-group", {
              hideElement: this.state.activeTab !== ACTIVE_CPD
            })}
          >
            <div className="row">
              {this.state.filters.cpd_hours.map((el, i) => (
                <RadioButton
                  key={i}
                  id={`${i}-cpd`}
                  type="cpd"
                  label={el.title}
                  checked={el.active}
                  handleChange={this.handleChangeCpHours}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="filter-group-holder" style={{marginTop: '20px'}}>
          <p
            className={classNames("filter-title custom-style-padding", {
              active: this.state.activeTab === ACTIVE_AUDIENCE
            })}
            onClick={() => this.activateTab(ACTIVE_AUDIENCE)}
          >
            Suitable for
          </p>
          <div
            className={classNames("filter-group", {
              hideElement: this.state.activeTab !== ACTIVE_AUDIENCE
            })}
          >
            {/* <div className="row"> */}
              {this.state.filters.audience.map(
                (el, i) => (
                  <Checkbox
                    key={`audience_${i}`}
                    value={el.value}
                    id={i}
                    label={el.title}
                    checked={el.checked}
                    handleChange={this.handleChangeCheckbox}
                    fullWidth
                  />
                )
              )}
            {/* </div> */}
          </div>
        </div>
        {this.state.isRegular && [
          <div className="filter-group-holder ">
            <p
              className={classNames("filter-title", {
                active: this.state.activeTab === ACTIVE_SELECT
              })}
              onClick={() => this.activateTab(ACTIVE_SELECT)}
            >
              COUNTY
            </p>
            <div
              className={classNames("filter-group", {
                hideElement: this.state.activeTab !== ACTIVE_SELECT
              })}
            >
              <div className="row select col-12 col-md-8">
                <FilterCountySelect
                  value={this.state.filters.venue_county}
                  name="venue_county"
                  elements={COUNTIES}
                  handleChange={this.handleChange}
                />
              </div>
            </div>
            <div className="filter-group-holder ">
              <p className="filter-title">DATE</p>
              <div className="filter-group">
                <div className="row">
                  <FilterDateSelect
                    placeholder="Date from"
                    key="1"
                    handleChange={this.handleChange}
                    name="date_from"
                    value={this.state.filters.date_from}
                  />
                  <FilterDateSelect
                    placeholder="Date to"
                    key="2"
                    handleChange={this.handleChange}
                    name="date_to"
                    value={this.state.filters.date_to}
                  />
                </div>
              </div>
            </div>
          </div>
        ]}
        <div className="btn-holder">
          <button className="btn bordered" type="submit" style={{backgroundColor: '#1ea2e8'}}>
            APPLY FILTER
          </button>
          <span onClick={() => this.resetFilters('refresh')}>RESET FILTER</span>
        </div>
      </form>
    );
  }

  renderRegularFilters = () => {
    return (
      <form
        className="filter"
        onSubmit={this.handleSubmit}
        style={this.props.style}
      >
        <h2 className="workshop-list-title workshop-list-top-holder  hide-xs hide-s">
          {this.state.defaultPrefix} WORKSHOPS
          <span>({this.state.count})</span>
        </h2>
        {this.state.isRegular && [
          <div className="filter-group-holder ">
            <p
              className={classNames("filter-title", {
                active: this.state.activeTab === ACTIVE_SELECT
              })}
              onClick={() => this.activateTab(ACTIVE_SELECT)}
            >
              COUNTY
            </p>
            <div
              className={classNames("filter-group", {
                hideElement: this.state.activeTab !== ACTIVE_SELECT
              })}
            >
              <div className="row select col-12 col-md-8">
                <FilterCountySelect
                  value={this.state.filters.venue_county}
                  name="venue_county"
                  elements={COUNTIES}
                  handleChange={this.handleChange}
                />
              </div>
            </div>
            <div className="filter-group-holder ">
              <p className="filter-title">DATE</p>
              <div className="filter-group">
                <div className="row">
                  <FilterDateSelect
                    placeholder="Date from"
                    key="1"
                    handleChange={this.handleChange}
                    name="date_from"
                    value={this.state.filters.date_from}
                  />
                  <FilterDateSelect
                    placeholder="Date to"
                    key="2"
                    handleChange={this.handleChange}
                    name="date_to"
                    value={this.state.filters.date_to}
                  />
                </div>
              </div>
            </div>
          </div>
        ]}
        <div className="filter-group-holder filter-group-holder-price">
          <p
            className={classNames("filter-title", {
              active: this.state.activeTab === ACTIVE_PRICE
            })}
            onClick={() => this.activateTab(ACTIVE_PRICE)}
            style={{ textTransform: "initial" }}
          >
            PRICE
          </p>
          <div
            className={classNames("filter-group", {
              hideElement: this.state.activeTab !== ACTIVE_PRICE
            })}
          >
            <div className="row">
              {this.state.filters.price.map((el, i) => (
                <RadioButton
                  key={i}
                  id={`${i}-price`}
                  type="price"
                  label={el.title}
                  checked={el.active}
                  handleChange={this.handleChangeRadioPrice}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="filter-group-holder filter-group-holder-cpd">
          <p
            className={classNames("filter-title", {
              active: this.state.activeTab === ACTIVE_CPD
            })}
            onClick={() => this.activateTab(ACTIVE_CPD)}
          >
            CPD HOURS
          </p>
          <div
            className={classNames("filter-group", {
              hideElement: this.state.activeTab !== ACTIVE_CPD
            })}
          >
            <div className="row">
              {this.state.filters.cpd_hours.map((el, i) => (
                <RadioButton
                  key={i}
                  id={`${i}-cpd`}
                  type="cpd"
                  label={el.title}
                  checked={el.active}
                  handleChange={this.handleChangeCpHours}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="filter-group-holder" style={{marginTop: '20px'}}>
          <p
            className={classNames("filter-title custom-style-padding", {
              active: this.state.activeTab === ACTIVE_AUDIENCE
            })}
            onClick={() => this.activateTab(ACTIVE_AUDIENCE)}
          >
            Suitable for
          </p>
          <div
            className={classNames("filter-group", {
              hideElement: this.state.activeTab !== ACTIVE_AUDIENCE
            })}
          >
            {/* <div className="row"> */}
              {this.handleSortAudience(this.state.filters.audience).map(
                (el, i) => (
                  <Checkbox
                    key={i}
                    value={el.value}
                    id={i}
                    label={el.title}
                    checked={el.checked}
                    handleChange={this.handleChangeCheckbox}
                    fullWidth
                  />
                )
              )}
            {/* </div> */}
          </div>
        </div>
        {/* <div className="filter-group-holder">
          <p
            className={classNames("filter-title custom-style-padding", {
              active: this.state.activeTab === ACTIVE_TYPE
            })}
            onClick={() => this.activateTab(ACTIVE_TYPE)}
          >
            Workshop Type
          </p>
          <div
            className={classNames("filter-group", {
              hideElement: this.state.activeTab !== ACTIVE_TYPE
            })}
          >
            <div className="row">
              {this.state.filters.workshop_type.map((el, i) => (
                // <RadioButton
                //   key={i}
                //   id={`${i}-type`}
                //   type="workshop_type"
                //   label={el.title}
                //   checked={el.active}
                //   handleChange={this.handleChangeWorkshopType}
                //   className={el.key === 'type_2' ? 'col-8' : 'col-4'}
                // />
                <Checkbox
                  key={i}
                  value={el.value}
                  // id={`${i}-type`}
                  id={i}
                  label={el.title}
                  checked={el.active}
                  handleChange={this.handleChangeWorkshopType}
                  fullWidth
                />
              ))}
            </div>
          </div>
        </div> */}
        <div className="btn-holder">
          <button className="btn bordered" type="submit" style={{backgroundColor: '#1ea2e8'}}>
            APPLY FILTER
          </button>
          <span onClick={() => this.resetFilters('refresh')}>RESET FILTER</span>
        </div>
      </form>
    );
  }

  renderFilters = type => {
    switch(type) {
      case "MY ONLINE":
      case "ONLINE":
      case "APPROVE":
      case "APPROVE_MODULE":
        return this.renderOnlineFilters();
      case "REGULAR":
        return this.renderRegularFilters();
      default:
        return this.renderOnlineFilters();
    }
  }

  render() {
    const isOrganization = this.state.filterTitle === 'organization';
    return !this.props.hideFilter && !isOrganization ? this.renderFilters(this.state.defaultPrefix) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/MyWorkShopFilters.jsx